import { routes as routesView } from "@/views/router";


import { RouteConfig } from 'vue-router';
export const routes: Array<RouteConfig> = [
  ...routesView
]

